import React from 'react';

// Same look as the static #splash in index.html — used as Suspense fallback
// while a lazy page chunk is fetched during client-side navigation.
export const SplashScreen = () => (
  <div id="splash-route" className="splash-route" data-testid="route-splash" aria-busy="true" aria-label="Laden">
    <img src="/jordievoorje-logo.png" alt="JorDievoorje" draggable={false} />
    <div className="splash-bar" />
    <div className="splash-text">Laden</div>
  </div>
);

export default SplashScreen;
